import { createSelector } from '@reduxjs/toolkit';
import type { AppState } from 'services/store';

export const selectSession: (state: AppState) => SessionState = createSelector(
	(state: AppState) => state.session,
	(session): SessionState => session,
);
